import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle';
import Scrollbar from '../../components/scrollbar';
import blogs from '../../api/blogs';
import BlogSingle from '../../components/BlogDetails/blog1';
import Footer from '../../components/footer';
import Logo from '../../images/logo.svg';

import SEO from '../../SEO';
import { getRouteMeta } from '../../seo/routes';

const BlogDetails = () => {
  const BlogDetails = blogs.find((item) => item.id === '1');

  return (
    <Fragment>
      <SEO {...getRouteMeta('/opinion/como-prevenir-y-proteger-la-salud-mental-de-sus-trabajadores')} />
      <Navbar
        hclass={'wpo-header-style-2'}
        Logo={Logo}
        topbarNone={'header-without-topbar'}
      />
      <PageTitle pageTitle={BlogDetails.title} pagesub={'Opinión'} />
      <BlogSingle />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default BlogDetails;
